var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("autocomplete", {
    attrs: {
      suggestions: _vm.searchResult,
      "name-field": "label",
      input: _vm.concept,
      update: _vm.update
    },
    on: {
      selected: _vm.onSelected,
      changed: _vm.onChanged,
      cleared: _vm.onCleared,
      activated: _vm.onFocus
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63972d9c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63972d9c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchField.vue
// module id = null
// module chunks = 